export const maxComboOptionInstruments = 6;
